import { Box, Typography } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { tableConfig } from "../../commons/table/config/tableConfig";
import TitleContainer from "../../commons/table/utilsTable/titleWithFetchData";
import { StyledUsers } from "../../styled/users";

const ProviderUserTable = ({
  data,
  loading,
  title,
  noRefresh,
  fetchData,
}) => {

  const columns = [
    {
      header: "Usuario",
      accessorKey: "email",
    },
    {
      header: "Nombre completo",
      accessorKey: "nombreCompleto",
      Cell: (rowData) => (
        <Typography variant="body2" color="textPrimary">
          {`${rowData.row.original.apellido}, ${rowData.row.original.nombre}`}
        </Typography>
      ),
      filterFn: (row, columnId, value) => {
        const nombreCompleto = `${row.original.apellido || ""}, ${row.original.nombre || ""
          }`;
        return nombreCompleto.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      header: "Estado",
      accessorKey: "pendiente",
      accessorFn: (row) => {
        return row.pendiente == 1 ? "Pendiente" : "Adherido"
      },
      filterVariant: 'select',
      filterSelectOptions: [{ label: "Pendiente", value: "Pendiente" }, { label: "Adherido", value: "Adherido" }],
    },
  ];

  return (
    <StyledUsers.TableContainer>
      <StyledUsers.ScrollContainer>
        <MaterialReactTable
          {...tableConfig}
          columns={columns}
          data={data}
          state={{ isLoading: loading }}
          renderTopToolbarCustomActions={() => (
            <Box m={0.5}>
              <TitleContainer
                title={title}
                noRefresh={noRefresh}
                fetchData={fetchData}
              />
            </Box>
          )}
        />
      </StyledUsers.ScrollContainer>
    </StyledUsers.TableContainer>
  );
};


export default ProviderUserTable;